export interface GetAllDto {
    recordsPerPage: number;
    pageNumber: number;
    sortBy: string;
    searchQuery?: string;
    contactId?: number;
    sortOrder: "ASC" | "DESC";
}
export class GetAllDto implements GetAllDto {
    recordsPerPage: number;
    pageNumber: number;
    sortBy: string;
    searchQuery?: string;
    contactId?: number;
    sortOrder: "ASC" | "DESC";
    constructor(sortBy: string, contactId?: number, searchQuery?: string, sortOrder?: ("ASC" | "DESC"), recordsPerPage?: number, pageNumber?: number) {
        this.sortBy = sortBy;
        this.contactId = contactId;
        this.sortOrder = sortOrder ?? "ASC"; /// sortOrder ? sortOrder: "ASC"
        this.recordsPerPage = recordsPerPage ?? 50;
        this.pageNumber = pageNumber ?? 1;
        this.searchQuery = searchQuery
    }
}